import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { BsChevronRight } from "react-icons/bs";
import TopBarRow from "../ui-elements/top-bar-row/top-bar-row.component";
import GoBackButton from "../ui-elements/gobackbutton";
import TitleActions from "../title-actions/TitleActions";
import { getPermissions } from "../../utils/permissions";
import { removeOneSpace } from "../../redux/space/space.actions";
import { saveHeaderDetails, deleteHeaderWorkspace, leaveHeaderWorkspace } from "../../firebase/headerActions";
import "./dock-header-styles.scss";

export default function DockHeader({ activeSpaceData, actions }) {
  const uid = useSelector(state => state.user.currentUser?.uid);
  const stations = useSelector(state => state.space.stationData) || [];
  const { wspaceid } = useParams();
  const spaceId = activeSpaceData?.spaceId || activeSpaceData?.id || wspaceid;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const space = { ...activeSpaceData, spaceId };
  const permissions = getPermissions(space, null, uid);
  const count = stations.filter(station => (station.fromSpaceId || station.spaceId) === spaceId).length;
  const canLeave = !!permissions.workspaceRole && permissions.workspaceRole !== "owner";
  const leaveOrDelete = async (leave) => {
    if (leave ? !canLeave : !permissions.canDeleteWorkspace) throw new Error("You no longer have permission to perform this action.");
    if (leave) await leaveHeaderWorkspace(spaceId, uid);
    else await deleteHeaderWorkspace(spaceId);
    dispatch(removeOneSpace(spaceId));
    navigate("/");
  };
  return <div className="dockHeader">
    <TopBarRow className="dH__upperRow">
      <GoBackButton />
      <TitleActions key={spaceId} kind="workspace" record={space}
        canEdit={permissions.canEditWorkspaceSettings} canDelete={permissions.canDeleteWorkspace} canLeave={canLeave}
        onSave={patch => {
          if (!permissions.canEditWorkspaceSettings) throw new Error("You no longer have permission to edit this workspace.");
          return saveHeaderDetails(spaceId, null, patch);
        }} onDelete={() => leaveOrDelete(false)} onLeave={() => leaveOrDelete(true)} />
      <BsChevronRight stroke="currentColor" strokeWidth={0.6} size="1em" className="dockHeader__chevron" aria-hidden="true" />
    </TopBarRow>
    <div className={`dH__bottomRow${actions ? " dH__bottomRow--actions" : ""}`}>
      {count ? <p>In this workspace you have <strong>{count}</strong> {count === 1 ? "project" : "projects"}.</p> : <p>In this workspace you don’t have any projects.</p>}
      {actions && <div className="dockHeader__actions">{actions}</div>}
    </div>
  </div>;
}
